var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"back",on:{"click":_vm.clickHandle}},[_vm._v("返回")]),_c('div',{staticClass:"title"},[_vm._v("免责声明")]),_c('div',{staticStyle:{"width":"40px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }